<template>
  <div>
    <b-card>
      <template #header>
        <b-row class="pt-1">
          <b-col cols="10" class="d-flex">
            <b-link :to="{name: 'Appearance'}">
              <h4 class="m-dir-2">
                {{label.pages.Appearance}}
              </h4>
            </b-link>
            /
            <h4 class="m-dirR-2">
              {{ $route.meta.label }}
              <small class="fw1">
                {{label.pages.manageSocialNetwork}}
              </small>
            </h4>
          </b-col>
          <b-col cols="2" class="dir-text-start">
            <a
                @click="$router.go(-1)"
                v-b-tooltip.hover.right
                :title="label.pages.previousPage"
                class="mouse-change pe-3"
            >
              <b-icon
                  icon="arrow-left-square-fill"
                  variant="ps-base"
                  scale="1.2"
                  class="align-middle ms-1"
              />
            </a>
          </b-col>
        </b-row>
      </template>
      <b-card-body>
        <b-card-text>
          <b-row
              class="my-1"
              v-for="social in socials"
              :key="social.id"
          >
            <b-col lg="1" md="1" sm="2">
              <div class="text-center">
                <img :src="social.iconAddress" class="p-2 rounded-2" v-b-tooltip="social.name" width="80px"/>
              </div>
            </b-col>
            <b-col lg="2" md="2" sm="4" class="add-links align-self-center">
              <label class="ps_label">
                {{label.pages.display}}
              </label>
              <label class="ps-switch m-dirR-2">
                <input type="checkbox" v-model="social.isActive">
                <span class="slider round"></span>
              </label>
            </b-col>
            <b-col lg="8" md="8" sm="6" class="d-flex my-4 align-self-center">
              <label class="ps_label align-self-center">
                {{label.pages.theAddress}}
              </label>
              <b-form-input id="address" size="lg" v-model="social.link" class="m-dirR-2 text-start fs-xlarge"/>
            </b-col>
            <hr/>
          </b-row>
        </b-card-text>
      </b-card-body>
      <template #footer>
        <div class="d-flex justify-content-end">
          <button
              @click="$router.go(-1)"
              class="m-dir-2"
              v-b-tooltip.hover
              size="sm"
              :title="label.pages.returnPage"
          >
            <b-icon
                icon="arrow-right-square-fill"
                scale="2"
                class="pt-1"
                variant="ps-secondary-icon"
            >
            </b-icon>
          </button>
          <b-button
              v-if="!loadingBtn"
              variant="ps-success"
              size="sm"
              class="mx-1"
              @click="edit"
          >
            <b-icon icon="check2-circle" class="ms-1"/>
            {{label.pages.saveChange}}
          </b-button>
          <b-button
              v-else
              disabled
              variant="ps-success"
              size="sm"
              class="mx-1"
          >
            <b-spinner small></b-spinner>
          </b-button>
        </div>
      </template>
    </b-card>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import label from "@/plugins/StaticLabels.js";

export default {
  name: 'SocialNetworks',
  data() {
    return {
      label,
    }
  },
  computed: {
    ...mapGetters({
      postCheck: 'postCheck',
      socials: 'baseX/socialNetworks',
      loadingBtn: 'loadingBtn',
    }),
  },
  watch: {
    postCheck() {
      if (this.postCheck === true) {
        this.reloadData();
      }
    },
  },
  methods: {
    edit() {
      this.$store.commit("setLoadingBtn", true);
      this.$store.dispatch('baseX/editSocialNetwork', this.socials);
    },
    reloadData() {
      this.$store.dispatch('baseX/getSocialNetworks');
    },
  },
  beforeCreate() {
    this.$store.dispatch('baseX/getSocialNetworks');
  },
}
</script>
